import { render, staticRenderFns } from "./VVariantDetailDialog.vue?vue&type=template&id=8721e936"
import script from "./VVariantDetailDialog.vue?vue&type=script&lang=js"
export * from "./VVariantDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports